import { createSlice } from '@reduxjs/toolkit';
import { IReduxState } from '../../interfaces/IReduxState';

interface IUpdate extends IReduxState<any> {
  updateableDate?: any;
}

export const UpdateDisplayDeviceSlicer = createSlice({
  name: 'UpdateDisplayDevice',
  initialState: {
    data: {},
    isLoading: false,
    updateableDate: {},
  } as IUpdate,
  reducers: {
    updateDisplayDevice: (state, _) => {
      state.isLoading = true;
    },
    successUpdateDisplayDevice: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    failureUpdateDisplayDevice: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    DisplayDeviceUpdateableData: (state, action) => {
      state.updateableDate = action.payload;
    },
    clearUpdateDisplayDeviceState: (state) => {
      state.data = {};
      state.updateableDate = undefined;
    },
  },
});

export const {
  updateDisplayDevice,
  successUpdateDisplayDevice,
  failureUpdateDisplayDevice,
  DisplayDeviceUpdateableData,
  clearUpdateDisplayDeviceState,
} = UpdateDisplayDeviceSlicer.actions;

export default UpdateDisplayDeviceSlicer.reducer;
